import { render, staticRenderFns } from "./EvaluationEvidenceResubmissionModal.vue?vue&type=template&id=2aa94f1a&"
import script from "./EvaluationEvidenceResubmissionModal.vue?vue&type=script&lang=js&"
export * from "./EvaluationEvidenceResubmissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports